<template>
    <div class="wlx-system-manager-wrapper">
        <div class="system-manager-head clearfix">
            <div class="school-logo-con fl">
                <img :src="schoolLogo" alt class="logo-img" />
            </div>
            <div class="fl system-manager-head-title">{{ certificateInfo.certificateName }}</div>
            <div class="fr system-stu-info-con clearfix">
                <router-link class="fl enter-to-back-home" :to="{ name: 'managerIndex' }" style="margin-right: 10px">
                    <i class="wl-icon-jiugongge" style="margin-right: 10px"></i>
                    <span>后台首页</span>
                </router-link>
                <router-link class="fl enter-to-back-home" :to="{ name: 'xHome' }" target="_blank">
                    <i class="wl-icon-shouye2"></i>
                    <span>前台首页</span>
                </router-link>
                <div class="head-user-logo-con fl">
                    <img :src="userLogo" alt />
                </div>
                <div class="fl head-user-info">
                    <span>{{ userInfo.userName }} </span>
                </div>
                <div class="fr get-out-sys" @click="outLogin">
                    <i class="wl-icon-dianyuan"></i>
                </div>
            </div>
        </div>
        <div class="system-manager-content clearfix">
            <div class="system-menu-con fl">
                <el-menu :unique-opened="true" :default-active="routerActive" :router="true" v-if="userInfo.userType == 5||(userInfo.userType == 15&&menuKeys.length>0)" size="small">
                    <el-submenu index="1" v-if="showMenu('x-mhgl')">
                        <template slot="title">
                            <i class="wl-icon-wangzhan"></i>
                            <span>门户管理</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-if="showMenu('x-mh-jbxx')" :index="'/wlx/system/' + certificateId + '/basic'"><i class="wl-icon-dian2"></i>基本管理</el-menu-item>
                            <el-menu-item v-if="showMenu('x-mh-xwgl')" :index="'/wlx/system/' + certificateId + '/news'"><i class="wl-icon-dian2"></i>新闻管理</el-menu-item>
                            <el-menu-item v-if="showMenu('x-mh-hzqy')" :index="'/wlx/system/' + certificateId + '/cooperate'"><i class="wl-icon-dian2"></i>合作企业</el-menu-item>
                            <el-menu-item v-if="showMenu('x-mh-hfgl')" :index="'/wlx/system/' + certificateId + '/banner'"><i class="wl-icon-dian2"></i>横幅管理</el-menu-item>
                            <el-menu-item v-if="showMenu('x-mh-jczc')" :index="'/wlx/system/' + certificateId + '/bannerManger'"><i class="wl-icon-dian2"></i>精彩之窗</el-menu-item>
                            <!-- <el-menu-item :index="'/wlx/system/'+certificateId+'/MangerWord'"><i class="wl-icon-dian2"></i>管理文档</el-menu-item>
                        <el-menu-item :index="'/wlx/system/'+certificateId+'/ExamOutLine'"><i class="wl-icon-dian2"></i>考核大纲</el-menu-item> -->
                            <el-menu-item v-if="showMenu('x-mh-wyhgl')" :index="'/wlx/system/' + certificateId + '/committee'"><i class="wl-icon-dian2"></i>委员会管理</el-menu-item>
                            <el-menu-item v-if="showMenu('x-mh-bysjytj')" :index="'/wlx/system/' + certificateId + '/statistical'"><i class="wl-icon-dian2"></i>毕业生就业统计</el-menu-item>
                            <el-menu-item v-if="showMenu('x-mh-hxrgl')" :index="'/wlx/system/' + certificateId + '/candidate'"><i class="wl-icon-dian2"></i>候选人管理</el-menu-item>
                            <el-menu-item v-if="showMenu('x-mh-zpgwxx')" :index="'/wlx/system/' + certificateId + '/jobsNeed'"><i class="wl-icon-dian2"></i>招聘岗位信息</el-menu-item>
                            <el-menu-item v-if="showMenu('x-mh-yhgl')" :index="'/wlx/system/' + certificateId + '/user'"><i class="wl-icon-dian2"></i>用户管理</el-menu-item>
                            <el-menu-item v-if="showMenu('x-mh-zsgl')" :index="'/wlx/system/' + certificateId + '/Xcertificate'"><i class="wl-icon-dian2"></i>证书管理</el-menu-item>

                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu v-if="showMenu('x-xmjs')" index="11">
                        <template slot="title">
                            <i class="wl-icon-diaocha"></i>
                            <span>项目介绍</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-if="showMenu('x-xmjs-xmjs')" :index="'/wlx/system/' + certificateId + '/ProjectIntroduce'"><i class="wl-icon-dian2"></i>项目介绍</el-menu-item>
                            <el-menu-item v-if="showMenu('x-xmjs-bzjs')" :index="'/wlx/system/' + certificateId + '/StandardConstruction'"><i class="wl-icon-dian2"></i>标准建设</el-menu-item>
                            <el-menu-item v-if="showMenu('x-xmjs-glwd')" :index="'/wlx/system/' + certificateId + '/MangerWord'"><i class="wl-icon-dian2"></i>管理文档</el-menu-item>
                            <el-menu-item v-if="showMenu('x-xmjs-khdg')" :index="'/wlx/system/' + certificateId + '/ExamOutLine'"><i class="wl-icon-dian2"></i>考核大纲</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu v-if="showMenu('x-zxdc')" :index="'/wlx/system/' + certificateId + '/pilot'">
                        <template slot="title">
                            <i class="wl-icon-diaocha"></i>
                            <span>在线调查</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-if="showMenu('x-zxdc-zxdc')" :index="'/wlx/system/' + certificateId + '/pilot'"><i class="wl-icon-dian2"></i>在线调查</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu v-if="showMenu('x-zdgl')" index="9">
                        <template slot="title">
                            <i class="wl-icon-yuanxiao"></i>
                            <span>站点管理</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-if="showMenu('x-zdgl-zdgl')"  :index="'/wlx/system/' + certificateId + '/adoptSchool'"><i class="wl-icon-dian2"></i>站点管理</el-menu-item>
                            <el-menu-item v-if="showMenu('x-zdgl-khzdsb')"  :index="'/wlx/system/' + certificateId + '/assessmentApply'"><i class="wl-icon-dian2"></i>考核站点申报</el-menu-item>
                            <el-menu-item v-if="showMenu('x-zdgl-sjgzs')"  :index="'/wlx/system/' + certificateId + '/provincialHead'"><i class="wl-icon-dian2"></i>省级工作室</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu v-if="showMenu('x-szpx')"  index="3">
                        <template slot="title">
                            <i class="wl-icon-peixun3"></i>
                            <span>师资培训</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-if="showMenu('x-szpx-pxhy')" index="http://sp.clppx.org.cn/index/meetRegister">
                                <a href="http://sp.clppx.org.cn/index/meetRegister" target="_blank"><i class="wl-icon-dian2"></i>培训会议</a>
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu v-if="showMenu('x-kpylx')"  index="4">
                        <template slot="title">
                            <i class="wl-icon-laoshi"></i>
                            <span>考评员遴选</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-if="showMenu('x-kpylx-kpylx')"  :index="'/wlx/system/' + certificateId + '/TeacherAppraiser'">考评员遴选</el-menu-item>
                            <!-- <el-menu-item>考评员证书</el-menu-item> -->
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu v-if="showMenu('x-jyjx')" index="5">
                        <template slot="title"> 
                            <i class="wl-icon-jiaoxueguanli"></i>
                            <span>教育教学</span> 
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-if="showMenu('x-jyjx-mnkh')" index="http://test.clppx.org.cn/login"
                                ><a href="http://test.clppx.org.cn/login" target="_blank"><i class="wl-icon-dian2"></i>模拟考核</a></el-menu-item
                            >
                            <el-menu-item v-if="showMenu('x-jyjx-jxpt')" index="http://ykt.clppx.org.cn/wlykt/home"
                                ><a href="http://ykt.clppx.org.cn/wlykt/home" target="_blank"><i class="wl-icon-dian2"></i>教学平台</a></el-menu-item
                            >
                            <el-menu-item v-if="showMenu('x-jyjx-jcrh')" :index="'/wlx/system/' + certificateId + '/teaBook'"><i class="wl-icon-dian2"></i>教材融合</el-menu-item>
                            <el-menu-item v-if="showMenu('x-jyjx-cjsp')" :index="'/wlx/system/' + certificateId + '/videoList'"><i class="wl-icon-dian2"></i>串讲视频</el-menu-item>
                            <el-menu-item v-if="showMenu('x-jyjx-wzpz')" :index="'/wlx/system/' + certificateId + '/webLink'"><i class="wl-icon-dian2"></i>网址配置</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu v-if="showMenu('x-kskh')" index="6">
                        <template slot="title">
                            <i class="wl-icon-kaoshi1"></i>
                            <span>考试考核</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-if="showMenu('x-kskh-kssb')" :index="'/wlx/system/' + certificateId + '/examDeclareManager'"><i class="wl-icon-dian2"></i>考试申报</el-menu-item>
                            <el-menu-item v-if="showMenu('x-kskh-ksddz')" :index="'/wlx/system/' + certificateId + '/FileManager'"><i class="wl-icon-dian2"></i>考试端地址</el-menu-item>
                            <el-menu-item v-if="showMenu('x-kskh-ksxxgl')" :index="'/wlx/system/' + certificateId + '/examInfoManager'"><i class="wl-icon-dian2"></i>考试信息管理</el-menu-item>
                            <el-menu-item v-if="showMenu('x-kskh-ssdp')" index="http://kw.clppx.org.cn/dataView"
                                ><a href="http://kw.clppx.org.cn/dataView" target="_blank"><i class="wl-icon-dian2"></i>实时大屏</a></el-menu-item
                            >
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu v-if="showMenu('x-cjzsgl')" index="10">
                        <template slot="title">
                            <i class="wl-icon-chengji"></i>
                            <span>成绩/证书管理</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-if="showMenu('x-cjzsgl-cjgl')" :index="'/wlx/system/' + certificateId + '/resultsManager'"><i class="wl-icon-dian2"></i>成绩管理</el-menu-item>
                            <el-menu-item v-if="showMenu('x-cjzsgl-zsgl')" :index="'/wlx/system/' + certificateId + '/certificateManager'"><i class="wl-icon-dian2"></i>证书管理</el-menu-item>
                            <el-menu-item v-if="showMenu('x-cjzsgl-szzsgl')" :index="'/wlx/system/' + certificateId + '/certificateManagerTea'"><i class="wl-icon-dian2"></i>师资证书管理</el-menu-item>
                            <el-menu-item v-if="showMenu('x-cjzsgl-zslx')" :index="'/wlx/system/' + certificateId + '/certificateTypeManager'"><i class="wl-icon-dian2"></i>证书类型</el-menu-item>
                            <el-menu-item v-if="showMenu('x-cjzsgl-zslxfl')" :index="'/wlx/system/' + certificateId + '/certificateTypeConfigManager'"><i class="wl-icon-dian2"></i>证书类型分类</el-menu-item>
                            <!-- <el-menu-item :index="'/wlx/system/' + certificateId + '/itcManager'"><i class="wl-icon-dian2"></i>ITC换证申请管理</el-menu-item> -->
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu v-if="showMenu('x-ifpsm')" index="12">
                        <template slot="title">
                            <i class="wl-icon-chengji"></i>
                            <span>IFPSM 证书互认换证管理</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-if="showMenu('x-ifpsm-pcgl')" :index="'/wlx/system/' + certificateId + '/itcBatchManager'"><i class="wl-icon-dian2"></i>IFPSM 证书互认批次管理</el-menu-item>
                            <el-menu-item v-if="showMenu('x-ifpsm-sqgl')" :index="'/wlx/system/' + certificateId + '/itcSiteManager'"><i class="wl-icon-dian2"></i>IFPSM 证书互认申请管理</el-menu-item>
                            <el-menu-item v-if="showMenu('x-ifpsm-sqgl')" :index="'/wlx/system/' + certificateId + '/itcPaperManager'"><i class="wl-icon-dian2"></i>IFPSM 纸质证书申请管理</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu v-if="showMenu('x-xmsq')" index="13">
                        <template slot="title">
                            <i class="wl-icon-kechengkaifa"></i>
                            <span>项目申请</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-if="showMenu('x-xmsq-xmgl')" :index="'/wlx/system/' + certificateId + '/projectManager'"><i class="wl-icon-dian2"></i>项目管理</el-menu-item>
                            <el-menu-item v-if="showMenu('x-xmsq-xmmbgl')" :index="'/wlx/system/' + certificateId + '/projectModelManager'"><i class="wl-icon-dian2"></i>项目模板管理</el-menu-item>
                            <!-- <el-menu-item :index="'/wlx/system/' + certificateId + '/customForm'"><i class="wl-icon-dian2"></i>表单生成器</el-menu-item> -->
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu v-if="showMenu('x-dsj')" index="7">
                        <template slot="title">
                            <i class="wl-icon-jichushuju"></i>
                            <span>大数据</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-if="showMenu('x-dsj-sddsj')" index="http://data.clppx.org.cn/X/view"
                                ><a href="http://data.clppx.org.cn/X/view" target="_blank"><i class="wl-icon-dian2"></i>试点大数据</a></el-menu-item
                            >
                            <el-menu-item v-if="showMenu('x-dsj-ksssjc')" index="http://kw.clppx.org.cn/dataView"
                                ><a href="http://kw.clppx.org.cn/dataView" target="_blank"><i class="wl-icon-dian2"></i>考试实时监测</a></el-menu-item
                            >
                            <el-menu-item v-if="showMenu('x-dsj-ksdsjfx')" index="http://kw.clppx.org.cn/examData"
                                ><a href="http://kw.clppx.org.cn/examData" target="_blank"><i class="wl-icon-dian2"></i>考试大数据分析</a></el-menu-item
                            >
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu v-if="showMenu('x-xjybgw')" index="https://vslc.ncb.edu.cn/csr-home">
                        <template slot="title">
                            <i class="wl-icon-wangzhan"></i>
                            <span>1+x教育部官网</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-if="showMenu('x-xjybgw-glpt')" index="https://vslc.ncb.edu.cn/csr-home"
                                ><a href="https://vslc.ncb.edu.cn/csr-home" target="_blank"><i class="wl-icon-dian2"></i>职业技能等级证书信息管理平台</a></el-menu-item
                            >
                            <el-menu-item v-if="showMenu('x-xjybgw-ptzy')" index="https://vslc.ncb.edu.cn/childIndex?orgCode=740088335"
                                ><a href="https://vslc.ncb.edu.cn/childIndex?orgCode=740088335" target="_blank"><i class="wl-icon-dian2"></i>X信息管理平台主页</a></el-menu-item
                            >
                        </el-menu-item-group>
                    </el-submenu>

                     <el-submenu v-if="userInfo.userName=='xguser'" :index="'/wlx/system/' + certificateId + '/permission'">
                        <template slot="title">
                            <i class="wl-icon-wangzhan"></i>
                            <span>权限管理</span>
                        </template>
                        <el-menu-item-group>
                             <el-menu-item :index="'/wlx/system/' + certificateId + '/permissionMenu'"><i class="wl-icon-dian2"></i>菜单管理</el-menu-item>
                             <el-menu-item :index="'/wlx/system/' + certificateId + '/permissionUser'"><i class="wl-icon-dian2"></i>用户管理</el-menu-item>       
                        </el-menu-item-group>
                    </el-submenu>
                </el-menu>
                <!-- 学员 -->
                <ul v-if="userInfo.userType == 1">
                    <li v-for="(item, index) in stuMenu" :key="index">
                        <router-link :to="{ name: item.name }" class="clearfix menu-li-item">
                            <i :class="item.icon"></i>
                            {{ item.title }}
                            <i class="wl-icon-xiangyou fr"></i>
                        </router-link>
                    </li>
                </ul>
                <!-- 讲师 -->
                <ul v-if="userInfo.userType == 2">
                    <li>
                        <router-link :to="{ name: 'teaPilotManager' }" class="clearfix menu-li-item">
                            <i class="wl-icon-yuanxiao"></i>
                            试点申报管理
                            <i class="wl-icon-xiangyou fr"></i>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'TrainApplyManager' }" class="clearfix menu-li-item">
                            <i class="wl-icon-mulupeizhi"></i>
                            申报管理
                            <i class="wl-icon-xiangyou fr"></i>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'assessmentApplyTea' }" class="clearfix menu-li-item">
                            <i class="wl-icon-zhandian"></i>
                            考核站点申请
                            <i class="wl-icon-xiangyou fr"></i>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'committeeManager' }" class="clearfix menu-li-item">
                            <i class="wl-icon-tuandui"></i>
                            委员会委员申请
                            <i class="wl-icon-xiangyou fr"></i>
                        </router-link>
                    </li>
                    <!-- <li>
                    <router-link :to="{name:'cerSignatureUpload'}" class="clearfix menu-li-item" v-if="userInfo.isExam==1">
                        <i class="wl-icon-tiaocha1"></i>
                        证书签名上传
                        <i class="wl-icon-xiangyou fr"></i>
                    </router-link>
                </li> -->
                </ul>
                <!-- 站长 -->
                <ul v-if="userInfo.userType == 3">
                    <li v-for="(item, index) in siteMenu" :key="index">
                        <router-link :to="{ name: item.name }" class="clearfix menu-li-item">
                            <i :class="item.icon"></i>
                            {{ item.title }}
                            <i class="wl-icon-xiangyou fr"></i>
                        </router-link>
                    </li>
                </ul>
                <!-- <ul>
                    <li>
                        <router-link :to="{ name: 'itcManager' }" class="clearfix">
                            <i class="wl-icon-zhengshu1"></i>
                            ITC换证申请管理
                            <i class="wl-icon-xiangyou fr"></i>
                        </router-link>
                    </li>
                </ul> -->
            </div>
            <div class="system-manager-con-main fr">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import { MU_UPATE_AUTH } from "store/index";
export default {
    data() {
        return {
            schoolLogo: require("assets/images/clpp-logo.png"),
            userLogo: require("assets/images/default_avatar3.png"),
            menuKeys:[],
            systemMenu: [
                {
                    title: "基本信息",
                    name: "basicInfo",
                    icon: "wl-icon-jibenxinxi",
                },
                {
                    title: "新闻管理",
                    name: "newsManager",
                    icon: "wl-icon-xinwen",
                },
                {
                    title: "合作企业",
                    name: "cooperaEnter",
                    icon: "wl-icon-kuajingzhifuiconqiye",
                },
                {
                    title: "横幅管理",
                    name: "bannerManager",
                    icon: "wl-icon-banner",
                },
                {
                    title: "精彩之窗",
                    name: "bannerManger",
                    icon: "wl-icon-xinwen",
                },
                {
                    title: "管理文档",
                    name: "MangerWord",
                    icon: "wl-icon-xinwen",
                },
                // {
                //   title: "站点管理",
                //   name: "sysSiteManager",
                //   icon: "wl-icon-zhandian"
                // },
                // {
                //   title: "教师申报管理",
                //   name: "lecturerManager",
                //   // name:"TeacherAudit",
                //   icon: "wl-icon-jiangshi"
                // },
                // {
                //   title: "学员管理",
                //   name: "sysStuManager",
                //   icon: "wl-icon-xueyuan"
                // },
                // {
                //   title: "资料管理",
                //   name: "sourseManager",
                //   icon: "wl-icon-shenbao"
                // },
                // {
                //   title: "站点管理",
                //   name: "siteManager",
                //   icon: "wl-icon-zhandian"
                // },
                // {
                //   title: "试点申报管理",
                //   name: "pilotManager",
                //   icon: "wl-icon-shenbao"
                // },
                // {
                //   title: "活动报名管理",
                //   name: "activityManager",
                //   icon: "wl-icon-shenbao"
                // },
                {
                    title: "委员会管理",
                    name: "committee",
                    icon: "wl-icon-shenbao",
                },
                // {
                //   title: "1+X物流考试管理",
                //   name: "exammanage",
                //   icon: "wl-icon-shenbao"
                // },
                // {
                //   title: "学习中心管理",
                //   name: "studyCenterManage",
                //   icon: "wl-icon-jiaocai"
                // },
                {
                    title: "用户管理",
                    name: "userManager",
                    icon: "wl-icon-yonghu",
                },
                {
                    title: "证书管理",
                    name: "XcertificateManager",
                    icon: "wl-icon-shenbao",
                },
            ],
            stuMenu: [
                {
                    title: "IFPSM纸质证书申请",
                    name: "stuPaperCertApply",
                    icon: "wl-icon-jibenxinxi",
                },
            ],
            teaMenu: [
                {
                    title: "基本信息",
                    name: "teaBasicInfo",
                    icon: "wl-icon-jibenxinxi",
                },
                {
                    title: "试点申报管理",
                    name: "teaPilotManager",
                    icon: "wl-icon-shenbao",
                },
            ],
            siteMenu: [
                {
                    title: "基本信息",
                    name: "siteBasicInfo",
                    icon: "wl-icon-jibenxinxi",
                },
                {
                    title: "讲师管理",
                    name: "siteteaManager",
                    icon: "wl-icon-jiangshi",
                },
                {
                    title: "培训管理",
                    name: "siteTrainManager",
                    icon: "wl-icon-peixun",
                },
                {
                    title: "考试管理",
                    name: "siteTestManager",
                    icon: "wl-icon-peixun",
                },
            ],
            certificateInfo: {},
            routerActive: this.$route.path,
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.auth;
        },
    },
    props: {
        certificateId: {
            type: String,
            default: "",
        },
    },
    created() {
        var that = this;

        if (localStorage["userId"] !== undefined) {
            that.$store.dispatch(MU_UPATE_AUTH).then((rt) => {});
        }
         this.getMenuKeys();
        this.getCertificateInfo();
   
    },
    methods: {
        showMenu(menukey){

             if(this.userInfo.userName=='xguser'||this.menuKeys.indexOf(menukey)>-1)
             {
                return true;
             }else{
                return false;
             }
        },
        getMenuKeys(){
        var that = this;
            this.$http
                .post("/api/XOrg/PermissionUser/getMenuKeys", {
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        debugger;
                        that.menuKeys = rst.menuKeys;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        getCertificateInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/Certificate/getCertificateInfo", {
                    id: this.certificateId,
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.certificateInfo = rst.certificateInfo;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        backToHome() {
            this.$router.push({
                name: "xHome",
            });
        },
        outLogin() {
            var that = this;
            this.$http.post("/api/XOrg/XLogin/outLogin").then(function (rst) {
                if (rst.code > 0) {
                    that.$store.commit(MU_UPATE_AUTH, null);
                    that.$router.push({
                        name: "xHome",
                    });
                } else {
                    that.$message.warning(rst.msg);
                }
            });
        },
    },
};
</script>

<style lang="scss"></style>
